'use strict';
var moduleName = 'clientDashboardApp.chatmeterAdmin.healthmeter';
const app = angular.module(moduleName, [])
  .config(function config($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.when('/healthmeter', '/healthmeter/providerStatus/summary');
    $urlRouterProvider.when('/healthmeter/listingStats', '/healthmeter/listingStats/summary');
    $stateProvider
      .state('healthmeter', {
        abstract: true,
        url: '/healthmeter',
        template: '<ui-view/>'
      })
      .state('healthmeter.providerStatus', {
        abstract: true,
        url: '/providerStatus',
        template: '<ui-view/>'
      })
      .state('healthmeter.providerStatus.summary', {
        url: '/summary?periodType&offset',
        template: require('./providerStatus/summary.html'),
        controller: 'providerJobStatusSummaryController'
      })
      .state('healthmeter.providerStatus.detail', {
        url: '/:provider?periodType&offset',
        template: require('./providerStatus/detail.html'),
        controller: 'providerJobStatusDetailController'
      })
      .state('healthmeter.listingStats', {
        abstract: true,
        url: '/listingStats',
        template: '<ui-view/>'
      })
      .state('healthmeter.listingStats.summary', {
        url: '/summary?periodType&offset',
        template: require('./listingStats/summary.html'),
        controller: 'listingStatsSummaryController'
      })
  });

require('./providerStatus/legend')(app);
require('./providerStatus/providerJobStatusDetailController')(app);
require('./providerStatus/providerJobStatusService')(app);
require('./providerStatus/providerJobStatusSummaryController')(app);
require('./timeperiod/timePeriodSelector')(app);
require('./timeperiod/timePeriodService')(app);

require('./listingStats/listingStatsSummaryController')(app);
require('./listingStats/listingStatsService')(app);
require('./listingStats/listingStatsRow').default(app);

module.exports = moduleName;
